import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7e475d44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-center textDark--text mb-10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mew-heading-2" }, "Select Token", -1))
const _hoisted_3 = { class: "d-flex mt-2" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "network-selected" }
const _hoisted_6 = { class: "px-8 pt-6" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mew-heading-4 mb-4" }, "Select Network", -1))
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "d-flex align-center" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "ml-2 my-2 d-flex flex-column" }
const _hoisted_12 = { class: "d-flex" }
const _hoisted_13 = { class: "d-flex token-container-overflow" }
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "text-capitalize text--bold" }

import { ref, Ref, computed } from "vue";
import { Crypto } from "../network/types";

import { storeToRefs } from "pinia";
import { useGlobalStore } from "@/plugins/globalStore";
import { Network } from "../network/types";
import BigNumber from "bignumber.js";
import { currencySymbols } from "../handler/prices";

export default /*#__PURE__*/_defineComponent({
  __name: 'TokenSelect',
  props: {
  close: {
    type: Function,
    default: () => ({}),
  },
  isSell: {
    type: Boolean,
    default: false,
  },
},
  emits: ["selectedNetwork", "selectCurrency", "close"],
  setup(__props, { emit: __emit }) {

const {
  selectedNetwork,
  buyNetworks,
  sellNetworks,
  cgPrice,
  conversionRates,
  selectedFiat,
} = storeToRefs(useGlobalStore());

const { setSelectedNetwork, setSelectedCrypto } = useGlobalStore();

// emit
const emit = __emit;

// props
const props = __props;

// reactive data
const networkSelected: Ref<Network> = ref<Network>(selectedNetwork.value);

const searchInput: Ref<string> = ref("");
const networkSearchInput: Ref<string> = ref("");

const filteredNetworkList: Ref<Network[]> = computed<Network[]>(() => {
  const withTokensNetwork = props.isSell
    ? sellNetworks.value
    : buyNetworks.value;
  const filter = networkSearchInput.value.toLowerCase();
  const filteredNetwork: Array<Network> = [];
  if (filter === "") return withTokensNetwork;
  withTokensNetwork.forEach((network) => {
    if (
      network.name.toLowerCase() === filter ||
      network.name_long.toLowerCase() === filter ||
      network.currencyName.toLowerCase() === filter
    )
      filteredNetwork.unshift(network);
    else if (
      network.name.toLowerCase().includes(filter) ||
      network.name_long.toLowerCase().includes(filter) ||
      network.currencyName.toLowerCase().includes(filter)
    )
      filteredNetwork.push(network);
  });
  return filteredNetwork;
});

const filteredNetworkTokens = computed<Crypto[]>(() => {
  const filterText = searchInput.value.toLowerCase();
  const tokensCopy = networkSelected.value.tokens?.slice();
  if (filterText === "") return tokensCopy;
  const filteredTokens: Array<Crypto> = [];
  tokensCopy.forEach((token) => {
    if (filteredTokens.some((t) => t.symbol === token.symbol)) return; // remove duplicates
    const tokenSymbol = token.symbol.toLowerCase();
    const tokenSubtext = token.subtext.toLowerCase();
    const tokenName = token.name.toLowerCase();
    if (
      tokenSymbol === filterText.toLowerCase() ||
      tokenName === filterText.toLowerCase()
    )
      filteredTokens.unshift(token);
    else if (
      tokenSymbol.includes(filterText.toLowerCase()) ||
      tokenName.includes(filterText.toLowerCase()) ||
      tokenSubtext.includes(filterText.toLowerCase())
    )
      filteredTokens.push(token);
  });
  return filteredTokens;
});

// methods
const selectNetwork = (passedNetwork: Network) => {
  setSelectedNetwork(passedNetwork);
  if (passedNetwork.tokens.length === 1) {
    setSelectedCrypto(passedNetwork.tokens[0]);
  } else {
    const findMain = passedNetwork.tokens.find(
      (token) => token.symbol === passedNetwork.name
    );
    if (findMain) {
      setSelectedCrypto(findMain);
    }
  }
  networkSelected.value = passedNetwork;
};

const selectCurrency = (token: Crypto) => {
  setSelectedCrypto(token);
  close();
};

const getPrice = (token: Crypto) => {
  const locale = "en-US";

  const price = token.price ? token.price : cgPrice.value.get(token.cgId);
  const selectedFiatValue = selectedFiat.value.name;
  const symbol = currencySymbols[selectedFiatValue]
    ? currencySymbols[selectedFiatValue]
    : "";
  const priceFormatted = price
    ? new Intl.NumberFormat(locale, {
        currency: selectedFiatValue,
      }).format(
        BigNumber(price)
          .times(conversionRates.value.get(selectedFiatValue))
          .toNumber()
      )
    : price;
  return price ? `${symbol}${priceFormatted}` : price; // returns blank for tokens without price
};

const close = () => {
  emit("close");
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_icon, {
        color: "textDark",
        class: "cursor-pointer",
        onClick: close
      }, {
        default: _withCtx(() => [
          _createTextVNode(" mdi-arrow-left mr-4 ")
        ]),
        _: 1
      }),
      _hoisted_2
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_select, {
          class: "full-width",
          label: "Network",
          modelValue: networkSelected.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((networkSelected).value = $event)),
          items: filteredNetworkList.value,
          "menu-props": { closeOnContentClick: true },
          "return-object": "",
          variant: "outlined"
        }, {
          selection: _withCtx(() => [
            _createElementVNode("img", {
              class: "network-icon mr-5 pa-1",
              src: networkSelected.value.icon,
              alt: networkSelected.value.name,
              width: "28px",
              height: "28px"
            }, null, 8, _hoisted_4),
            _createElementVNode("span", _hoisted_5, _toDisplayString(networkSelected.value.name_long), 1)
          ]),
          "prepend-item": _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_v_text_field, {
                modelValue: networkSearchInput.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((networkSearchInput).value = $event)),
                variant: "outlined",
                class: "mr-1",
                "prepend-inner-icon": "mdi-magnify",
                placeholder: "Search",
                autofocus: true,
                onClick: _cache[1] || (_cache[1] = _withModifiers((e) => e.preventDefault(), ["stop"]))
              }, null, 8, ["modelValue"])
            ])
          ]),
          item: _withCtx((data) => [
            _createElementVNode("div", {
              class: "d-flex align-center justify-space-between full-width cursor-pointer px-8 pb-6",
              onClick: ($event: any) => (selectNetwork(data.item.value))
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("img", {
                  class: "currency-icon padding--2 mr-1 ml-3",
                  src: data.item.value.icon,
                  alt: data.item.value.name,
                  width: "25px",
                  height: "25px"
                }, null, 8, _hoisted_10),
                _createElementVNode("span", _hoisted_11, _toDisplayString(data.item.value.name_long), 1)
              ])
            ], 8, _hoisted_8)
          ]),
          _: 1
        }, 8, ["modelValue", "items"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_v_text_field, {
          modelValue: searchInput.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchInput).value = $event)),
          variant: "outlined",
          class: "mr-1",
          "prepend-inner-icon": "mdi-magnify",
          placeholder: "Search",
          autofocus: true
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_v_list, {
          lines: "one",
          class: "full-width"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredNetworkTokens.value, (item, i) => {
              return (_openBlock(), _createBlock(_component_v_list_item, {
                key: i,
                value: item,
                "base-color": "primary",
                onClick: ($event: any) => (selectCurrency(item))
              }, {
                prepend: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "currency-icon no-border mr-3",
                    src: item.img,
                    alt: item.name,
                    width: "25px",
                    height: "25px"
                  }, null, 8, _hoisted_14)
                ]),
                append: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(getPrice(item)), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(item.symbol), 1),
                        _createElementVNode("span", null, _toDisplayString(` - ${item.name}`), 1)
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["value", "onClick"]))
            }), 128))
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})